import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]
  static classes = ["dark"]

  connect() {
    this.initializeTheme()
  }

  initializeTheme() {
    const savedTheme = this.getCookie("theme")

    if (savedTheme) {
      this.setTheme(savedTheme)
    } else {
      // Check system preference
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
      const theme = prefersDark ? "dark" : "light"
      this.setTheme(theme)
      this.setCookie("theme", theme, 365) // Save for 1 year
    }

    // Listen for system theme changes
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e) => {
      // Only update if no saved preference exists
      if (!this.getCookie("theme")) {
        const theme = e.matches ? "dark" : "light"
        this.setTheme(theme)
      }
    })
  }

  toggle() {
    const currentTheme = document.body.classList.contains("dark") ? "dark" : "light"
    const newTheme = currentTheme === "dark" ? "light" : "dark"

    this.setTheme(newTheme)
    this.setCookie("theme", newTheme, 365)
  }

  setTheme(theme) {
    if (theme === "dark") {
      document.body.classList.add("dark")
    } else {
      document.body.classList.remove("dark")
    }
  }

  getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
      return parts.pop().split(';').shift()
    }
    return null
  }

  setCookie(name, value, days) {
    const expires = new Date()
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000))
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`
  }
}
